import { HeaderNavTab } from "@bessemercws/components";
import { UserProfileType } from "@bessemercws/graphql";

export const headerLinksByUserProfileType: Record<UserProfileType, { links: HeaderNavTab[], homeLink: string }> = {
  Tax: {
    homeLink: 'documents/tax',
    links: [
      {
        label: 'Documents',
        to: 'documents/tax',
      },
    ]
  }
}